import { Component, ViewChild, AfterViewInit, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService, TranslateService } from '@services';
import { Company, CompanyExperience, ContentProvider, OverviewProvider, ReportingProvider, ExternalContentProvider } from '@lighty';
import { CommonModalComponent } from '@common2/components/modal/modal.component';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CarouselComponent } from 'ngx-owl-carousel-o';
import { take } from 'rxjs';
import { th } from 'date-fns/locale';
import { Title } from '@angular/platform-browser';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from '@env/environment';
import { UrlHelper } from '@helpers';
import { WidgetNextEventComponent } from './widgets/next-event/next-event.component';



@Component({
    selector: 'msc-learn-overview',
    templateUrl: './overview.component.html',
    styleUrls: ['./overview.component.scss'],
})
export class LearnOverviewComponent implements AfterViewInit, OnDestroy {
    @ViewChild('modalOnboarding') modalOnboarding: CommonModalComponent;
    @ViewChild('carouselRecentlyViewed', { static: false }) carouselRecentlyViewed!: CarouselComponent;
    @ViewChild('carouselBestQualified', { static: false }) carouselBestQualified!: CarouselComponent;
    @ViewChild('carouselRecommended', { static: false }) carouselRecommended!: CarouselComponent;
    // Mensaje de bienvenida: clamp a 3 líneas con "Ver más / Ver menos"
    @ViewChild('announceText', { static: false }) announceText?: ElementRef<HTMLParagraphElement>;
    @ViewChild('nextEventWidget', { static: false }) nextEventWidget?: WidgetNextEventComponent;
    public announceExpanded: boolean = false;
    public announceOverflowing: boolean = false;
    public me: any;
    public company: Company;
    public sidebar: any;

    /** Nombre corto del usuario activo: primer nombre + primer apellido. */
    get shortName(): string {
        const first = (this.me?.firstname || '').trim().split(/\s+/)[0] || '';
        const last = (this.me?.lastname || '').trim().split(/\s+/)[0] || '';
        return (first + ' ' + last).trim() || (this.me?.name || '');
    }
    public experience: CompanyExperience;
    public announce: any;
    public modalResources: any;
    public modalExtras: any;
    public modalNews: any;
    backdrop: any;
    public contents: any[] = [];
    public topRecomendations: any[] = [];
    public recommendedCompanyContentsByLearner: any[] = [];
    public isLoading: boolean = false;
    public currentOpenModal: string = '';
    public isLoadingSkeleton = true;
    // [SCROLL-TO-TOP] Controla la visibilidad del botón de volver arriba
    public showScrollTop: boolean = false;
    private sliderInitialized = false;
    private _sliderCurrentSlide: ((n: number) => void) | null = null;
    private _autoSlideInterval: any = null;
    public bannerInfo: any[] = [];
    public currentBannerTimer: number = 5000;
    public resources: any[] = [];
    public recommendedByCompanyTitle: string = '';
    public userCourseAndTimeStats: any;
    public totalEnrolled: number = 0; // total de cursos inscritos (denominador de los anillos)
    // Finalizados reales (desde suscripciones), separados por tipo
    public completedCourses: number = 0;
    public totalCourses: number = 0;
    public completedJourneys: number = 0;
    public totalJourneys: number = 0;
    public isLoadingStats: boolean = false;
    public baseUrl: string = '';
    public grikySkillsEnabled = false;
    public academicProfileEnabled = false;
    externalContentProvider: any;
    public currentJob: string = 'learn';


    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private overviewProvider: OverviewProvider,
        private storageService: StorageService,
        private contentProvider: ContentProvider,
        private translateService: TranslateService,
        private titleService: Title,
        private cdr: ChangeDetectorRef,
        private reportingProvider: ReportingProvider,
        private externalContentProvider2: ExternalContentProvider,

    ) { }

    ngOnInit(): void {
        this.me = this.storageService.get('me');
        this.company = this.storageService.get('company');
        this.sidebar = this.storageService.get('sidebar');
        this.experience = this.company.experience;
        this.titleService.setTitle(this.company?.experience?.name);
        if (!this.experience) {
            this.overviewProvider
                .getAnnounce(this.company.id)
                .subscribe((data) => {
                    this.announce = data;
                });
        }

        this.baseUrl = localStorage.getItem('baseUrl');

        // Simula la carga de skeleton en 5 segundos 
        this.getBannerTime();
        /* setTimeout(() => {
            this.isLoadingSkeleton = false;

            // << Nuevo: después de ocultar el skeleton, inicializar el banner-slider
            setTimeout(() => {
                this.initBannerSlider();
            }, 50);

        }, 5000); */
        this.recommendedByCompanyTitle = this.translateService.instant('words.recommended-by') + ' ' + this.company.name;
        this.grikySkillsEnabled = !!(this.company as any)?.permissions?.grikySkillsModule;
        this.academicProfileEnabled = !!(this.company as any)?.permissions?.academicProfileModule;
        this.getBannerInfo();
        this.getContent();
        this.loadCompletionStats();
        this.getTopRecomendations();
        this.getRecommendedCompanyContentsByLearner();
        this.getUserCourseAndTimeStats();
    }

    ngAfterViewInit() {
        this.modalResources = document.getElementById('modal-resources');
        this.modalExtras = document.getElementById('modal-extras');
        this.modalNews = document.getElementById('modal-news');
        this.backdrop = document.getElementById('backdrop');

        this.route.queryParams.subscribe((params) => {
            if (params.actions && params.actions === 'unlock-onboarding') {
                this.modalOnboarding.onOpen();
            }
        });

        this.checkAnnounceOverflow();
    }

    /**
     * Determina si el mensaje de bienvenida supera las 3 líneas (clamp) para
     * mostrar el botón "Ver más". Compara la altura real del texto contra la
     * altura visible con el clamp aplicado.
     */
    private checkAnnounceOverflow(): void {
        setTimeout(() => {
            const el = this.announceText?.nativeElement;
            this.announceOverflowing = !!el && el.scrollHeight > el.clientHeight + 1;
            this.cdr.detectChanges();
        });
    }

    /** Alterna entre mostrar 3 líneas y el texto completo del mensaje de bienvenida. */
    public toggleAnnounce(): void {
        this.announceExpanded = !this.announceExpanded;
    }

    // skeleton<< Nuevo: método que contiene toda la lógica del banner-slider
    private initBannerSlider(): void {
        if (this.sliderInitialized) { return; }
        console.log('initBannerSlider called with bannerInfo length:', this.bannerInfo.length);
        const bannerTime = this.currentBannerTimer
        this.sliderInitialized = true;

        let slideIndex = 1;
        let isHovered = false;

        const carouselContainer = document.querySelector('.slider-imagenes-portada') as HTMLElement;
        const nextBtn = document.getElementById('next');
        const prevBtn = document.getElementById('prev');

        // Seleccionar elementos DENTRO del contenedor del slider
        const getSlides = () => carouselContainer?.querySelectorAll('.mySlides') || [];
        const getDescripciones = () => carouselContainer?.querySelectorAll('.descripcion-portada') || [];
        const getBars = () => document.querySelectorAll('.banner2-bars .slide-bar') || [];

        const showSlides = (n: number) => {
            const slides = getSlides();
            const descripcionPortada = getDescripciones();
            const bars = getBars();

            console.log('showSlides - slides:', slides.length, 'descripciones:', descripcionPortada.length, 'bars:', bars.length);

            if (slides.length === 0 || descripcionPortada.length === 0) {
                console.warn("Slider aún no montado completamente.", {slides: slides.length, descrip: descripcionPortada.length});
                return;
            }

            if (n > slides.length) { slideIndex = 1; }
            if (n < 1) { slideIndex = slides.length; }

            // Ocultar todos
            slides.forEach((slide) => {
                (slide as HTMLElement).style.display = "none";
            });
            descripcionPortada.forEach((desc) => {
                (desc as HTMLElement).style.display = "none";
            });
            bars.forEach((bar) => {
                (bar as HTMLElement).classList.remove("active");
            });

            // Mostrar el actual
            (slides[slideIndex - 1] as HTMLElement).style.display = "flex";
            (descripcionPortada[slideIndex - 1] as HTMLElement).style.display = "flex";
            if (bars[slideIndex - 1]) {
                (bars[slideIndex - 1] as HTMLElement).classList.add("active");
            }

            console.log('Showing slide:', slideIndex);
        };

        const plusSlides = (n: number) => {
            slideIndex += n;
            showSlides(slideIndex);
            resetAutoSlide();
        };

        const currentSlide = (n: number) => {
            slideIndex = n;
            showSlides(slideIndex);
            resetAutoSlide();
        };

        const startAutoSlide = () => {
            this._autoSlideInterval = setInterval(() => {
                plusSlides(1);
            }, bannerTime);
        };

        const stopAutoSlide = () => {
            clearInterval(this._autoSlideInterval);
        };

        const resetAutoSlide = () => {
            stopAutoSlide();
            if (!isHovered) {
                startAutoSlide();
            }
        };

        // Inicia el slider
        showSlides(slideIndex);
        startAutoSlide();

        // Hover para pausar/reanudar
        carouselContainer?.addEventListener('mouseenter', () => {
            isHovered = true;
            stopAutoSlide();
        });
        carouselContainer?.addEventListener('mouseleave', () => {
            isHovered = false;
            startAutoSlide();
        });

        // Flechas next/prev
        nextBtn?.addEventListener('click', () => plusSlides(1));
        prevBtn?.addEventListener('click', () => plusSlides(-1));

        // Swipe táctil (solo móvil)
        let touchStartX = 0;
        let touchEndX = 0;
        const SWIPE_THRESHOLD = 50;

        carouselContainer?.addEventListener('touchstart', (e: TouchEvent) => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        carouselContainer?.addEventListener('touchend', (e: TouchEvent) => {
            touchEndX = e.changedTouches[0].screenX;
            const diff = touchStartX - touchEndX;
            if (Math.abs(diff) > SWIPE_THRESHOLD) {
                plusSlides(diff > 0 ? 1 : -1);
            }
        }, { passive: true });

        // Bar indicators — click handled via Angular template (currentSlide public method)
        this._sliderCurrentSlide = currentSlide;

        // Opcional: exponer en window si lo usas global
        (window as any).plusSlides = plusSlides;
        (window as any).currentSlide = currentSlide;

        //this.modal = document.getElementById('modal');
        this.modalResources = document.getElementById('modal-resources');
        this.modalExtras = document.getElementById('modal-extras');
        this.modalNews = document.getElementById('modal-news');
        this.backdrop = document.getElementById('backdrop');
    }


    public openCoronaSiemens(): void {
        const url = 'https://siacademy4r.com/auth/saml2/login.php';
        this.externalContentProvider2.storeUserToken(url)
            .subscribe((token: string) => {
                UrlHelper.navigate(`${environment.envVar.AUTHORIZATION_SERVER_URL}/authenticated-redirect?token=${token}`);
            })
    }

    openModal(modal: string): void {
        this.currentOpenModal = modal;
        switch (modal) {
            case 'resources':
                this.modalResources.classList.remove('translate-x-full');
                this.backdrop.classList.remove('hidden');
                break;
            case 'extras':
                this.modalExtras.classList.remove('translate-x-full');
                this.backdrop.classList.remove('hidden');
                this.nextEventWidget?.load();
                break;
            case 'news':
                this.modalNews.classList.remove('translate-x-full');
                this.backdrop.classList.remove('hidden');
                break;
            default:
                break;
        }
        // this.modal.classList.remove('translate-x-full');
        this.backdrop.classList.remove('hidden');

    }

    closeModal(modal?: string): void {
        modal = modal || this.currentOpenModal;
        switch (modal) {
            case 'resources':
                this.modalResources.classList.add('translate-x-full');
                break;
            case 'extras':
                this.modalExtras.classList.add('translate-x-full');
                break;
            case 'news':
                this.modalNews.classList.add('translate-x-full');
                break;
            default:
                break;
        }
        //this.modal.classList.add('translate-x-full');
        this.currentOpenModal = '';
        this.backdrop.classList.add('hidden');
    }

    getAnnouncePicture(): string {
        if (this.experience && this.experience.announcePicture) {
            return 'url(' + this.experience.announcePicture + '?size=512' + ')';
        } else if (this.announce && this.announce.dashboardMedia) {
            return 'url(' + this.announce.dashboardMedia + '?size=512' + ')';
        }
        return '';
    }

    catalogue(): void {
        this.router.navigate(['../catalogue'], { relativeTo: this.route });
    }

    //flechas carousel cards

    public prev(origin: string): void {
        switch (origin) {
            case 'carouselRecentlyViewed':
                this.carouselRecentlyViewed.prev();
                break;
            case 'carouselBestQualified':
                this.carouselBestQualified.prev();
                break;
            case 'carouselRecommended':
                this.carouselRecommended.prev();
                break;
            default:
                break;
        }
    }

    public next(origin: string): void {
        switch (origin) {
            case 'carouselRecentlyViewed':
                this.carouselRecentlyViewed.next();
                break;
            case 'carouselBestQualified':
                this.carouselBestQualified.next();
                break;
            case 'carouselRecommended':
                this.carouselRecommended.next();
                break;
            default:
                break;
        }
    }


    public getContent(): void {
        this.isLoading = true;
        this.contents = [
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true }
        ];
        const params = {
            company_id: this.company.id,
            per_page: 10
        };
        this.contentProvider.getContents(params).pipe(take(1)).subscribe((data) => {
            this.contents = data.contents;
            this.totalEnrolled = (data.pagination && data.pagination.total) ? data.pagination.total : (data.contents ? data.contents.length : 0);
            this.isLoading = false;
        });
    }

    /**
     * Calcula el stroke-dashoffset del anillo (circunferencia ~113.1) según el
     * porcentaje value/total. value=0 o sin total → anillo vacío.
     * Para "horas" se pasa total=100 (el valor se usa como porcentaje directo).
     */
    public ringOffset(value: number, total: number): number {
        const circumference = 113.1;
        const pct = total > 0 ? Math.min(100, (Number(value) || 0) / total * 100) : 0;
        return circumference - (circumference * pct / 100);
    }

    /**
     * Cuenta cursos/rutas completados vs totales para los anillos de progreso del overview.
     *
     * IMPORTANTE: a diferencia del perfil académico (que cuenta TODO junto en
     * computeStatusCounts), aquí SÍ se SEPARA por tipo:
     *   - cursos  → type !== 'traject'  → completedCourses / totalCourses
     *   - rutas   → type === 'traject'  → completedJourneys / totalJourneys
     * Se calcula desde course-subscriptions/completion-stats (agregado en el backend, no
     * per_page=1000 contra /course-subscriptions) porque el reporting /aggs no trae esta data
     * fiable (devolvía 0).
     */
    public loadCompletionStats(): void {
        this.contentProvider.getCompletionStats(this.company.id).pipe(take(1)).subscribe((stats) => {
            this.completedCourses = stats.completedCourses ?? 0;
            this.totalCourses = stats.totalCourses ?? 0;
            this.completedJourneys = stats.completedJourneys ?? 0;
            this.totalJourneys = stats.totalJourneys ?? 0;
        });
    }

    public getTopRecomendations(): void {
        this.topRecomendations = [
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true }
        ];
        this.contentProvider.getUserTopRecomendations(this.company.id).pipe(take(1)).subscribe((data) => {
            this.topRecomendations = data.recommendations;
            this.isLoading = false;
        });
    }

    public getRecommendedCompanyContentsByLearner(): void {
        this.recommendedCompanyContentsByLearner = [
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true },
            { isSkeleton: true }
        ];
        this.contentProvider.getRecommendedCompanyContentsByLearner(this.company.id, this.experience.id).pipe(take(1)).subscribe((data) => {
            this.recommendedCompanyContentsByLearner = data.recommendations;
            this.isLoading = false;
        });
    }

    public getBannerInfo(): void {
        console.log('getBannerInfo');
        this.bannerInfo = [];
        clearInterval(this._autoSlideInterval);
        this.sliderInitialized = false;
        this.contentProvider.getOverviewBannerInfo(this.company.id, this.experience.id).pipe(take(1)).subscribe((data) => {
            const raw = data.data ?? data;
            this.bannerInfo = Array.isArray(raw) ? raw : Object.values(raw || {});
            console.log('bannerInfo', this.bannerInfo.length, this.bannerInfo);
            this.isLoadingSkeleton = false;
            this.cdr.detectChanges();

            // Esperar al siguiente ciclo de renderizado
            setTimeout(() => {
                if (this.bannerInfo.length > 0) {
                    this.initBannerSlider();
                }
            }, 100);
        })
    }

    public convertSecondsToHoursMinutes(seconds: number): string {
        if (seconds < 0 || isNaN(seconds)) {
            return '0h0m';
        }
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return `${hours}h${minutes}m`;
    }

    public getBannerTime(): void {
        this.contentProvider.getBannerDuration(this.company.id, this.experience.id).pipe(take(1)).subscribe((data) => {
            if (data) {
                this.currentBannerTimer = data.bannerTransitionDuration
            } else {
                this.currentBannerTimer = 5000;
            }
        });
    }


    public getActionUrl(url): string {
        const startIndex = url.indexOf('/learn');
        return url.slice(startIndex);
    }

    public getUserCourseAndTimeStats(): void {
        this.isLoadingStats = true;
        this.reportingProvider.getAccountOverview(this.storageService.get('company').id, this.storageService.get('me').id).subscribe((data) => {
            this.userCourseAndTimeStats = data;
            this.isLoadingStats = false;
        });
    }

    public getDuration(): any {
        let time: number = 0;
        let translate: string = 'overview.stats.time.minute';

        if (this.userCourseAndTimeStats) {
            if (this.userCourseAndTimeStats.duration > 0 && this.userCourseAndTimeStats.duration < 3600) {
                time = Math.round(this.userCourseAndTimeStats.duration / 60);
                translate = 'overview.stats.time.minutes';
            } else if (this.userCourseAndTimeStats.duration >= 3600) {
                time = Math.round(this.userCourseAndTimeStats.duration / 3600);
                translate = (time > 1) ? 'overview.stats.time.hours' : 'overview.stats.time.hour';
            }
        }

        return [time, translate];
    }

    public currentSlide(n: number): void {
        if (this._sliderCurrentSlide) {
            this._sliderCurrentSlide(n);
        }
    }

    ngOnDestroy(): void {
        clearInterval(this._autoSlideInterval);
        this.sliderInitialized = false;
        this._sliderCurrentSlide = null;
    }

    // [SCROLL-TO-TOP] Escucha el scroll de la ventana; muestra el botón al superar 300px de desplazamiento
    @HostListener('window:scroll', [])
    onWindowScroll(): void {
        this.showScrollTop = window.scrollY > 300;
    }

    // [SCROLL-TO-TOP] Desplaza la página suavemente hasta el tope
    scrollToTop(): void {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // [SCROLL-TO-TOP] Devuelve true si el floating-chat IA está habilitado en la empresa,
    // para posicionar el botón por encima del ícono del chat y no sobreponerlo
    get isChatEnabled(): boolean {
        return this.company?.permissions?.companyAiAssistant === true;
    }

}
